import { useEffect, useState } from 'react'
import { useFirestore } from 'reactfire'
import {
  collection,
  getCountFromServer,
  query,
  where,
} from 'firebase/firestore'

/**
 * Whether the company has a contract paid a fixed monthly salary, which the
 * LODAS export can only write with a salary Lohnart.
 *
 * Null while unknown. A failed count is reported as true: the warning it
 * gates is cheaper to show once too often than to miss.
 */
export function useHasSalariedContracts(companyUid, enabled) {
  const firestore = useFirestore()
  const [hasSalaried, setHasSalaried] = useState(null)

  useEffect(() => {
    if (!enabled || !companyUid) {
      setHasSalaried(null)
      return undefined
    }
    let cancelled = false
    getCountFromServer(
      query(
        collection(firestore, 'contracts'),
        where('employer.uid', '==', companyUid),
        where('remuneration.type', '==', 'fixed'),
        where('deleted', '==', false)
      )
    )
      .then((snap) => {
        if (!cancelled) setHasSalaried(snap.data().count > 0)
      })
      .catch(() => {
        if (!cancelled) setHasSalaried(true)
      })
    return () => {
      cancelled = true
    }
  }, [firestore, companyUid, enabled])

  return hasSalaried
}
